import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../shared/common.service";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  adminUser: boolean = true;
  clubUser: boolean = false;
  LoginFlag: boolean = true;
  ResetFlag: boolean = false;
  Loginmessage: string = "";
  isLoading: boolean = false;
  resetForm: FormGroup;

  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  constructor(
    private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.initialiseForms();
    localStorage.clear();
  }

  initialiseForms() {
    this.loginForm = this.fb.group({
      userName: [
        "",
        [Validators.required, Validators.pattern(this.emailPattern)],
      ],
      password: ["", [Validators.required]],
      role: ["admin", Validators.required],
    });
    this.resetForm = this.fb.group({
      userName: [
        "",
        [Validators.required, Validators.pattern(this.emailPattern)],
      ],
    });
  }

  loginFN() {
    this.router.navigate(["main/dashboard"]);
  }

  login() {
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      let req = {
        email: this.loginForm.controls["userName"].value.trim(),
        password: this.loginForm.controls["password"].value,
        // role: this.loginForm.controls["role"].value,
      };
      this.isLoading = true;
      if (this.loginForm.controls["role"].value == "admin") {
        this.authServices.validateLogin(req).subscribe(
          (res: HttpResponse<any>) => {
            if ((res["message"] = "Success")) {
              this.isLoading = false;
              this.commonService.setStorage(
                "token",
                res.headers.get("Authorization")
              );
              localStorage.setItem("role", "admin");
              // this.commonService.setStorage(
              //   "subRole",
              //   JSON.stringify(res.body.data.response[0].subRole)
              // );
              // let obj = {
              //   dashboard: "W",
              //   merchant: "W",
              //   roles: "W",
              //   users: "W",
              //   invoices: "W",
              //   drivers: "W",
              //   order: "W",
              //   coupon: "W",
              //   banner: "W",
              //   pickDropSettings: "W",
              //   fares: "W",
              //   refund: "W",
              //   influencer: "W",
              //   city: "W",
              //   setting: "W",
              //   audit: "W",
              //   serviceArea: "W",
              //   payout : "W",
              // };
              //  localStorage.setItem("_per", JSON.stringify(obj));
              // this.commonService.setStorage(
              //   "_per",
              //   JSON.stringify(res.body.data.response[0].permissions)
              // );
              // let userData = this.commonService.getUser();
              localStorage.setItem("activeIndex", "0");

              this.router.navigate(["main/dashboard"]);
              
            } else {
            }
          },
          (err) => {
            this._snackBar.open(err.error.data, "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["failure"],
            });
            setTimeout(() => {
              this.isLoading = false;
            }, 400);}
        );
      }
      if (this.loginForm.controls["role"].value == "dispatcher") {
        this.authServices.validateDispatcherLogin(req).subscribe(
          (res: HttpResponse<any>) => {
            this.isLoading = false;
            if ((res["message"] = "Success")) {
              this.commonService.setStorage(
                "token",
                res.headers.get("Authorization")
              );
              localStorage.setItem("role", "dispatcher");
              // this.commonService.setStorage(
              //   "subRole",
              //   JSON.stringify(res.body.data.response[0].subRole)
              // );
              // let obj = {
              //   dashboard: "W",
              //   merchant: "W",
              //   roles: "W",
              //   users: "W",
              //   invoices: "W",
              //   drivers: "W",
              //   order: "W",
              //   coupon: "W",
              //   banner: "W",
              //   pickDropSettings: "W",
              //   fares: "W",
              //   refund: "W",
              //   influencer: "W",
              //   city: "W",
              //   setting: "W",
              //   audit: "W",
              //   serviceArea: "W",
              //   payout : "W",
              // };
              //  localStorage.setItem("_per", JSON.stringify(obj));
              // this.commonService.setStorage(
              //   "_per",
              //   JSON.stringify(res.body.data.response[0].permissions)
              // );
              // let userData = this.commonService.getUser();
              localStorage.setItem("activeIndex", "0");

              this.router.navigate(["main/dashboard"]);
            } else {
            }
          },
          (err) => {
            this._snackBar.open(err.error.data, "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["failure"],
            });
            this.isLoading = false;
          }
        );
      }
    }
  }
  show: boolean = false;
  password() {
    this.show = !this.show;
  }
  resetPassword() {
    this.formSubmitted = true;
    if (this.resetForm.valid) {
      let req = {
        email: this.resetForm.controls["userName"].value.trim(),
      };
      this.isLoading = true;
      this.authServices.resetPassword(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            this.navigatePassword();
            this._snackBar.open("Password sent to the registered Email!!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  navigatePassword() {
    this.LoginFlag = !this.LoginFlag;
    this.initialiseForms();
  }
}
